<svg class="svg_icon--alert" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
  <defs>
    <style>.svg_icon--alert .icon{fill:currentColor;}</style>
  </defs>
  <circle class="icon" cx="50" cy="50" r="41.67"/>
  <line class="icon" x1="50" y1="33.33" x2="50" y2="50" stroke="white" stroke-width="8.33" stroke-linecap="round" fill="none"/>
  <line class="icon" x1="50" y1="66.67" x2="50.04" y2="66.67" stroke="white" stroke-width="8.33" stroke-linecap="round" fill="none"/>
</svg>